import { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button } from '@mui/material';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useVerifyEmailTokenMutation } from '../../redux/Apis/Auth';
import { authErrorMessage } from '../../utils/authSession';
export default function TokenVerify() {
  const { token: routeToken } = useParams();
  const location = useLocation();
  const token = routeToken || new URLSearchParams(location.search).get('token');
  const [verify] = useVerifyEmailTokenMutation();
  const request = useRef(null);
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    let active = true;
    if (!token) { setState({ error: 'Verifieringslänken saknas. Begär en ny länk.' }); return; }
    if (request.current?.token !== token || request.current?.attempt !== attempt) {
      request.current = { token, attempt, promise: verify(token).unwrap() };
    }
    setState({ loading: true });
    request.current.promise.then(() => { if (active) setState({ success: true }); },
      (failure) => { if (active) setState({ error: authErrorMessage(failure, 'Länken är ogiltig eller har redan använts.') }); });
    return () => { active = false; };
  }, [token, attempt, verify]);
  return <Box sx={{ maxWidth: 500, mx: 'auto', my: 6, px: 2 }}>
    <h1>Verifiera e-post</h1>
    {state.loading && <p role="status">Verifierar…</p>}
    {state.success && <Alert severity="success">Din e-postadress är verifierad. Du kan nu logga in.</Alert>}
    {state.error && <><Alert severity="error">{state.error}</Alert>{token && <Button onClick={() => setAttempt(attempt + 1)}>Försök igen</Button>}<p><Link to="/verify-email">Begär en ny verifieringslänk</Link></p></>}
    <p><Link to="/auth/login">Logga in</Link></p>
  </Box>;
}
